import SwapVert from '@mui/icons-material/SwapVert';
import MuiIconSvg, { MuiIconSvgProps } from "components/MuiExtras/MuiIconSvg";
import * as React from "react";

type Props = Omit<MuiIconSvgProps, "icon">;

const IconSort: React.FunctionComponent<Props> = (props) => {

    return <MuiIconSvg {...props} icon={SwapVert} />;
};

export default IconSort;
